import {Component, Inject, OnInit} from "@angular/core";
import {Message, StoreInfo} from "../../../../shared-utilities/models-old/datastructures";
import {readOperationalEventTimestamp} from "../../../../shared/shared-utils/firestore/operational-server-timestamp.utils";

@Component({
  selector: "app-msg-user-signup-notification",
  templateUrl: "./msg-user-signup-notification.component.html",
  styleUrls: ["./msg-user-signup-notification.component.scss"],
  standalone: false
})
export class MsgUserSignupNotificationComponent implements OnInit {

  //  “{{email}}” the link you created at {{time}} on {{date}}.<br>
  //   {{userName}}.
  email: string;
  time: string;
  date: string;
  userNameMsg: string;

  constructor(
    @Inject("INPUT") private useValue: {
      id: number | string;
      message: Message<{[key: string]: string | boolean | Date}>;
      getStoreInfo(storeId: string, isStore: boolean): StoreInfo | {value: string; name?: string};
    }
  ) {
  }

  ngOnInit(): void {
    const msg = this.useValue.message;
    this.email = msg.payload.data.email.toString();
    const at = readOperationalEventTimestamp(msg.timestamp) ?? new Date();
    this.time = at.toLocaleTimeString();
    this.date = `${at.getDate()}/${at.getMonth()}/${at.getFullYear()}`;
    this.userNameMsg = msg.payload.data.userName ? `The user chose the username: "${msg.payload.data.userName}"` :
      "No username was provided.";
  }

}
